import { Table } from '@dreryk/react-components';

import { TABLE_PAGE_SIZE } from '../shared/constants';

import {
   useDiagnosisInformationDataConfiguration,
   useDiagnosisInformationTableColumns,
} from './DiagnosisInformationTable.hooks';
import { DiagnosisInformationTableDataAccessor } from './DiagnosisInformationTable.utils';

type DiagnosisInformationTableProps = {
   readonly patientId: number;
   readonly highlightedEntryId?: number;
};

export const DiagnosisInformationTable = (props: DiagnosisInformationTableProps): JSX.Element => {
   return (
      <Table
         testId={'diagnosisInformation'}
         columns={useDiagnosisInformationTableColumns({
            patientId: props.patientId,
         })}
         dataConfiguration={useDiagnosisInformationDataConfiguration(props.patientId)}
         pageSize={TABLE_PAGE_SIZE}
         dataAccessor={DiagnosisInformationTableDataAccessor}
         keyExtractor={'id'}
         highlightedRowKey={props.highlightedEntryId}
      />
   );
};
